// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {
  Button,
  ButtonSizes,
  ButtonVariants,
} from '@wandb/weave/components/Button';
import React from 'react';

import {SettingLevel} from '../../../../services/analytics/workspaceSettingsEvents';

export type ResetSettingButtonProps = {
  className?: string;
  isEnabled: boolean;
  settingLevel: SettingLevel;
  onButtonClick: () => void;
};

export const ResetSettingButton = ({
  className,
  isEnabled,
  settingLevel,
  onButtonClick,
}: ResetSettingButtonProps) => {
  if (settingLevel === 'workspace') {
    return null;
  }

  if (!isEnabled) {
    return <div className="h-32 w-32" />;
  }

  return (
    <Button
      className={className}
      aria-label="Reset"
      disabled={!isEnabled}
      icon="randomize-reset-reload"
      onClick={onButtonClick}
      size={ButtonSizes.Medium}
      tooltip="Reset"
      variant={ButtonVariants.Ghost}
    />
  );
};
